import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { SERVER_URL } from "../../constant";
import AlertBox from "../../component/AlertBox";
import {
  LinearProgress,
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@mui/material";
import DialogBox from "../../component/DialogBox";
import ButtonCompo from "../../component/ButtonCompo";
import InputField from "../../component/InputField";
import { GoFile } from "react-icons/go";
import { MdOutlineFileDownload } from "react-icons/md";
import { AiOutlineEdit } from "react-icons/ai";
import { AiOutlineDelete } from "react-icons/ai";
import SelectField from "../../component/SelectField";
import { DatePicker } from "@mui/x-date-pickers";
import dayjs from "dayjs";
import { FiAlertCircle } from "react-icons/fi";

function EmployeeHrDocumentManagement() {
  const { userId } = useParams();
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [success, setSuccess] = useState(false);
  const [message, setMessage] = useState("");
  const [employeeData, setEmployeeData] = useState([]);
  const [hrDocuments, setHrDocuments] = useState([]);
  const fileRef = useRef(null);
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [file, setFile] = useState(null);
  const [employeeUpload, setEmployeeUpload] = useState(false);
  const [reload, setReload] = useState(false);
  const [expiryDate, setExpiryDate] = useState(dayjs());

  // fetch employee data
  async function getEmployee() {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/employee/get/employee/${userId}`,
        method: "get",
        withCredentials: true,
      });
      console.log(res.data?.data);
      setEmployeeData(res.data?.data);
      // console.log(res.data?.data?.hrDocs);
      const rawData = res.data?.data?.hrDocs;
      let finalData = [];
      if (Array.isArray(rawData)) {
        rawData.map((data, i) => {
          const now = dayjs();
          const targetedDate = dayjs(data?.expiryDate);
          let obj = {};
          console.log(targetedDate.isBefore(now));
          if (targetedDate.isBefore(now)) {
            obj = { ...data, datePassed: true };
          } else {
            obj = { ...data, datePassed: false };
          }
          finalData.push(obj);
        });
      }
      setHrDocuments(finalData);
    } catch (error) {
      setOpen(true);
      setSuccess(false);
      setMessage("Employee fetch failed");
    } finally {
      setLoading(false);
    }
  }

  //add doc
  async function addDoc() {
    if (title?.length === 0 || description?.length === 0 || file === null) {
      setOpen(true);
      setSuccess(false);
      setMessage("Please fill all the fields and choose a file");
      return null;
    }
    const formData = new FormData();
    formData.append("hr_document", file);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("employeeUpload", employeeUpload);
    formData.append("userId", userId);
    formData.append("expiryDate", expiryDate);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hr/documents/add`,
        method: "post",
        withCredentials: true,
        data: formData,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Document added successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // set edit value
  function setValue(data) {
    setTitle(data?.title);
    setDescription(data?.description);
    setEmployeeUpload(data?.employeeUpload);
    setExpiryDate(dayjs(data?.expiryDate));
    // console.log(data?.expiryDate)
  }

  //edit doc
  async function editDoc(prevTitle) {
    const formData = new FormData();
    formData.append("hr_document", file);
    formData.append("title", title);
    formData.append("description", description);
    formData.append("employeeUpload", employeeUpload);
    formData.append("userId", userId);
    formData.append("prevTitle", prevTitle);
    formData.append("expiryDate", expiryDate);
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hr/documents/edit`,
        method: "put",
        withCredentials: true,
        data: formData,
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Document edited successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  //delete doc
  async function deleteDoc(data) {
    try {
      setLoading(true);
      const res = await axios({
        url: `${SERVER_URL}/api/v1/admin/hr/documents/delete`,
        method: "delete",
        withCredentials: true,
        data: {
          userId: userId,
          fileData: {
            hrFile: data?.hrFile,
            title: data?.title,
          },
        },
      });
      if (res.status >= 200 || res.status < 400) {
        setReload((prev) => !prev);
        setOpen(true);
        setSuccess(true);
        setMessage("Document deleted successfully");
      }
    } catch (error) {
      setReload((prev) => !prev);
      setOpen(true);
      setSuccess(false);
      setMessage(error?.response?.data?.message);
      console.log(error);
    } finally {
      setLoading(false);
    }
  }

  // employee upload options
  const employeeUploadArr = [
    {
      title: "Yes",
      value: true,
    },
    {
      title: "No",
      value: false,
    },
  ];

  useEffect(() => {
    getEmployee();
  }, [userId, reload]);

  return (
    <>
      {loading && (
        <LinearProgress className="!fixed !top-0 !left-0 !right-0 !h-[8px]" />
      )}
      <div className="w-full flex justify-center items-center">
        {success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        {!success && (
          <AlertBox
            open={open}
            setOpen={setOpen}
            success={success}
            title={message}
          />
        )}
        <div className="w-[90vw] py-5">
          <div className="w-full">
            <div className="w-full flex justify-center items-center flex-col gap-2 mt-5">
              <section className="w-[6rem] h-[6rem]">
                <img
                  src={`${SERVER_URL}/api/v1/file/view/${employeeData?.logo}`}
                  alt=""
                  className="w-full h-full object-cover rounded-full"
                />
              </section>
              <p className="text-[18px] font-medium">
                {employeeData?.fullName}
              </p>
            </div>
            <div className="w-full mt-5">
              <h3 className="font-medium">HR Documents</h3>
              {hrDocuments === undefined || hrDocuments?.length === 0 ? (
                <div className="w-full flex justify-center items-center flex-col mt-5">
                  <p className="font-medium text-slate-400 mb-3">
                    No documents added yet
                  </p>
                  <DialogBox
                    trigger={<ButtonCompo>Add A File</ButtonCompo>}
                    title="Add Document"
                    actionButton={
                      <ButtonCompo onClick={addDoc}>Save</ButtonCompo>
                    }
                    closeActionButton={<ButtonCompo>close</ButtonCompo>}
                  >
                    <div className="w-full space-y-5">
                      <input
                        type="file"
                        className="hidden"
                        ref={fileRef}
                        onChange={(event) => setFile(event?.target?.files[0])}
                      />
                      <InputField
                        label="Title"
                        onChange={(event) => setTitle(event?.target?.value)}
                      />
                      <InputField
                        label="Description"
                        multiline
                        onChange={(event) =>
                          setDescription(event?.target?.value)
                        }
                      />
                      <SelectField
                        label={"Employee File Upload"}
                        value={employeeUpload}
                        setValue={(e) => setEmployeeUpload(e?.target?.value)}
                        valueArray={employeeUploadArr}
                      />
                      <DatePicker
                        onChange={(val) => setExpiryDate(val)}
                        label="Last Date of Acknowledgement"
                        className="!w-full"
                      />
                      <section
                        onClick={() => fileRef.current.click()}
                        className="bg-slate-100/10 py-5 flex justify-center px-3 items-center w-full border border-dashed border-slate-400/80 rounded-[5px] cursor-pointer"
                      >
                        <p className="text-slate-800/80 text-[15.5px] flex flex-col justify-center items-center gap-1 font-medium">
                          Upload Document
                          {file !== null && (
                            <span className="text-slate-500">
                              1 document selected
                            </span>
                          )}
                        </p>
                      </section>
                    </div>
                  </DialogBox>
                </div>
              ) : (
                <div className="w-full flex justify-center items-center flex-col mt-5">
                  <div className="flex justify-end items-end w-full mb-3">
                    <DialogBox
                      trigger={<ButtonCompo>Add A File</ButtonCompo>}
                      title="Add Document"
                      actionButton={
                        <ButtonCompo onClick={addDoc}>Save</ButtonCompo>
                      }
                      closeActionButton={<ButtonCompo>close</ButtonCompo>}
                    >
                      <div className="w-full space-y-3">
                        <input
                          type="file"
                          className="hidden"
                          ref={fileRef}
                          onChange={(event) => setFile(event?.target?.files[0])}
                        />
                        <InputField
                          label="Title"
                          onChange={(event) => setTitle(event?.target?.value)}
                        />
                        <InputField
                          label="Description"
                          multiline
                          onChange={(event) =>
                            setDescription(event?.target?.value)
                          }
                        />
                        <SelectField
                          label={"Employee File Upload"}
                          value={employeeUpload}
                          setValue={(e) => setEmployeeUpload(e?.target?.value)}
                          valueArray={employeeUploadArr}
                        />
                        <DatePicker
                          onChange={(val) => setExpiryDate(val)}
                          label="Last Date of Acknowledgement"
                          className="!w-full"
                        />
                        <section
                          onClick={() => fileRef.current.click()}
                          className="bg-slate-100/10 py-5 flex justify-center px-3 items-center w-full border border-dashed border-slate-400/80 rounded-[5px] cursor-pointer"
                        >
                          <p className="text-slate-800/80 text-[15.5px] flex flex-col justify-center items-center gap-1 font-medium">
                            Upload Document
                            {file !== null && (
                              <span className="text-slate-500">
                                1 document selected
                              </span>
                            )}
                          </p>
                        </section>
                      </div>
                    </DialogBox>
                  </div>
                  <Table>
                    <TableBody className="border">
                      {hrDocuments?.map((e, i) => (
                        <TableRow>
                          <TableCell>
                            <div className="flex gap-3 items-center">
                              <span className="bg-slate-200/50 p-2 rounded-full">
                                <GoFile className="text-[20px] text-slate-800" />
                              </span>
                              <div>
                                <p className="font-medium">
                                  {e?.title}{" "}
                                  <Link
                                    className="ml-2 bg-blue-200/60 px-3 py-1 rounded-full font-medium text-blue-600"
                                    to={`${SERVER_URL}/api/v1/file/view/${e?.hrFile}`}
                                    target="_blank"
                                  >
                                    View
                                  </Link>{" "}
                                </p>
                                <p className="text-slate-500 mt-2">
                                  {e?.description}
                                </p>
                              </div>
                            </div>
                          </TableCell>
                          <TableCell>
                            Uploaded At{" "}
                            <span className="bg-slate-200/70 px-3 py-1 rounded-full text-slate-700 font-medium">
                              {new Date(e?.date).toLocaleDateString("en-US", {
                                timeZone: "Asia/Kolkata",
                              })}
                            </span>
                          </TableCell>
                          <TableCell>
                            Last date of Acknowledgement{" "}
                            <span className="bg-slate-200/70 px-3 py-1 rounded-full text-slate-700 font-medium">
                              {new Date(e?.expiryDate).toLocaleDateString(
                                "en-US",
                                {
                                  timeZone: "Asia/Kolkata",
                                }
                              )}
                            </span>
                            {e?.datePassed === true && e?.status === "Waiting" ? (
                              <section className="flex items-center gap-1 mt-2 text-red-500">
                                <span>
                                  <FiAlertCircle
                                    size={17}
                                    className="text-red-500"
                                  />
                                </span>
                                Last date of acknowledgement has been passed.
                              </section>
                            ) : (
                              ""
                            )}
                          </TableCell>
                          <TableCell>
                            {e?.status === "Waiting" ? (
                              <span className="bg-yellow-200/70 px-3 py-1 rounded-full text-yellow-700 font-medium">
                                Waiting for Acknowledgement
                              </span>
                            ) : e?.status === "Denied" ? (
                              <span className="bg-red-200/70 px-3 py-1 rounded-full text-red-700 font-medium">
                                {e?.status}
                              </span>
                            ) : (
                              <span className="bg-green-200/70 px-3 py-1 rounded-full text-green-700 font-medium">
                                {e?.status}
                              </span>
                            )}
                          </TableCell>
                          <TableCell>
                            {e?.employeeFile === undefined ? (
                              <span className="flex gap-2 w-[10rem] items-center bg-slate-200/50 font-medium px-2 rounded-[5px] text-slate-500 justify-center py-2">
                                <MdOutlineFileDownload size={"20px"} /> Reply
                              </span>
                            ) : (
                              <Link
                                className="flex gap-2 w-[10rem] items-center bg-blue-200/30 font-medium px-2 rounded-[5px] text-blue-600/90 justify-center py-2"
                                to={`${SERVER_URL}/api/v1/file/view/${e?.employeeFile}`}
                                target="_blank"
                              >
                                <MdOutlineFileDownload size={"20px"} /> Reply
                              </Link>
                            )}
                          </TableCell>
                          <TableCell>
                            <DialogBox
                              trigger={
                                <div
                                  className="flex gap-3 items-center cursor-pointer"
                                  onClick={() => setValue(e)}
                                >
                                  <span className="bg-blue-200/50 p-2 rounded-full">
                                    <AiOutlineEdit className="text-[20px] text-slate-800" />
                                  </span>
                                </div>
                              }
                              title="Edit Document"
                              actionButton={
                                <ButtonCompo onClick={() => editDoc(e?.title)}>
                                  Save
                                </ButtonCompo>
                              }
                              closeActionButton={
                                <ButtonCompo>close</ButtonCompo>
                              }
                            >
                              <div className="w-full space-y-3">
                                <input
                                  type="file"
                                  className="hidden"
                                  ref={fileRef}
                                  onChange={(event) =>
                                    setFile(event?.target?.files[0])
                                  }
                                />
                                <InputField
                                  label="Title"
                                  onChange={(event) =>
                                    setTitle(event?.target?.value)
                                  }
                                  value={title}
                                />
                                <InputField
                                  label="Description"
                                  multiline
                                  onChange={(event) =>
                                    setDescription(event?.target?.value)
                                  }
                                  value={description}
                                />
                                <SelectField
                                  label={"Employee File Upload"}
                                  value={employeeUpload}
                                  setValue={(e) =>
                                    setEmployeeUpload(e?.target?.value)
                                  }
                                  valueArray={employeeUploadArr}
                                />
                                <DatePicker
                                  onChange={(val) => setExpiryDate(val)}
                                  label="Last Date of Acknowledgement"
                                  className="!w-full"
                                  value={expiryDate}
                                />
                                <section
                                  onClick={() => fileRef.current.click()}
                                  className="bg-slate-100/10 py-5 flex justify-center px-3 items-center w-full border border-dashed border-slate-400/80 rounded-[5px] cursor-pointer"
                                >
                                  <p className="text-slate-800/80 text-[15.5px] flex flex-col justify-center items-center gap-1 font-medium">
                                    Upload Document
                                    {file !== null && (
                                      <span className="text-slate-500">
                                        1 document selected
                                      </span>
                                    )}
                                  </p>
                                </section>
                              </div>
                            </DialogBox>
                          </TableCell>
                          <TableCell>
                            <div
                              className="flex gap-3 items-center cursor-pointer"
                              onClick={() => deleteDoc(e)}
                            >
                              <span className="bg-red-200/50 p-2 rounded-full">
                                <AiOutlineDelete className="text-[20px] text-slate-800" />
                              </span>
                            </div>
                          </TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EmployeeHrDocumentManagement;
